export const MODIFY_ALL_QUERIES = 'MODIFY_ALL_QUERIES';

export function modifyAllQueries(allQueries){
    return{
        type: MODIFY_ALL_QUERIES,
        mainState: {
            allQueries: allQueries
        }
    }
}